"use client";

import { Header as AuthHeader } from "@/components/auth/Header";
import { Legal } from "@/components/auth/Legal";
import { buttonVariants } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface ICardWrapperProps {
    children: React.ReactNode;
    inModal: boolean;
    headerLabel: string;
    headerDescription?: string;
    backButtonLabel: string;
    isLogging?: boolean;
    onSwitch: () => void;
}

export const CardWrapper = ({ children, inModal, isLogging, headerLabel, headerDescription, backButtonLabel, onSwitch }: ICardWrapperProps) => {
    return (
        <Card className={ cn("shadow-md", {
            "border-none": inModal,
            "w-[400px] border": !inModal,
        }) }>
            <CardHeader>
                <AuthHeader label={ headerLabel } description={ headerDescription } />
            </CardHeader>
            <CardContent>{children}</CardContent>
            <CardFooter className="flex flex-col space-y-8">
                {isLogging ? <Legal isLogging={ isLogging } /> : null }
                <div className={ cn("font-normal mx-auto cursor-pointer", buttonVariants({ variant: "link" }), "text-foreground h-0 px-0") } onClick={ onSwitch }>
                    {backButtonLabel}
                </div>
            </CardFooter>
        </Card>
    );
};
